export const goalStepsFeatureKey = 'goal-steps';
